import constants from 'pages/ScheduleCalendar/constants';
import displayLogic from 'pages/ScheduleCalendar/duck/displayLogic';
import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import text from 'strings/text';

export function ManageApplicantModalComponent({approveApplicantDispatch, denyApplicantDispatch, cancelModal, presentedShift, selectedApplicant, willApproveApplicant}) {

    const approveTitle = (<FormattedMessage id="ManageApplicant.approveTitle" defaultMessage="Approve this applicant?" />);
    const approveLastTitle = (<FormattedMessage id="ManageApplicant.approveLastTitle" defaultMessage="Approve Applicant?" />);
    const denyTitle = (<FormattedMessage id="ManageApplicant.denyTitle" defaultMessage="Deny this applicant?" />);

    const approveBody = (<FormattedMessage id="ManageApplicant.approveLastBody" defaultMessage="Make sure you have considered regulations related to overtime, minor work rules, scheduling legislation, etc." />);
    const approveLastBody = (<FormattedMessage id="ManageApplicant.approveBody" defaultMessage="Once you approve this applicant they will be assigned to work this shift. Any pending applicants will be auto-denied and notified." />);
    const denyBody = (<FormattedMessage id="ManageApplicant.denyBody" defaultMessage="Once you deny this applicant, all parties will be notified. We recommend sending a comment to the applicant to explain why it was denied." />);

    const handleConfirm = () => {
        if(willApproveApplicant) {
            approveApplicantDispatch(presentedShift.id, selectedApplicant);
        } else {
            denyApplicantDispatch(presentedShift.id, selectedApplicant);
        }
        cancelModal();
    }

    const handleCancel = () => {
        cancelModal();
    }   

    const getTitle = (type) => {
        if( type == constants.ManageApplicantActionType.approve){
            return approveTitle;
        }else if ( type == constants.ManageApplicantActionType.approveLast){
            return approveLastTitle;
        }else{
            return denyTitle;
        }
    }

    const getBodyText = (type) => {
        if( type == constants.ManageApplicantActionType.approve){
            return approveBody;
        }else if ( type == constants.ManageApplicantActionType.approveLast){
            return approveLastBody;
        }else{
            return denyBody;
        }
    }

    const type = displayLogic.getManageApplicantActionType(presentedShift, willApproveApplicant);

    return (
        <div className="manage-applicant-modal">
            <label className="title averta-regular fs20px">{getTitle(type)}</label>
            <div className='body-text1'>{getBodyText(type)}</div>

            <div className="last-row-wrap">
                <div className='cta-right-group'>
                    <button className="confirm-button-cancel averta-semibold fs14px" onClick={handleCancel}>{text.cancel}</button>
                    <button className={"confirm-button averta-semibold fs14px button-enabled"} onClick={handleConfirm}>{text.confirm}</button>
                </div>
            </div>
        </div>
    );
}